import { LetterTemplatesTable } from "features/templates/letter";

export { LetterTemplatesTable };

export const LetterTemplatesPage = () => {
  return <LetterTemplatesTable />;
};
